import { Auth0Client } from '@auth0/auth0-spa-js';
import { HIGHSCHOOL_SCOPE } from '#/constants';
import type { Auth0Config } from '#/config';

// auth0-spa-js は Authorization Code + PKCE を自動で行う（SPA 向け public client）。
// API 用トークンではなく highschool クレームが必要なため audience は指定せず scope で要求する。
export function createAuth0Client(config: Auth0Config) {
  return new Auth0Client({
    domain: config.domain,
    clientId: config.clientId,
    authorizationParams: {
      scope: `openid email profile ${HIGHSCHOOL_SCOPE}`,
      redirect_uri: `${window.location.origin}/result`,
    },
  });
}
